/* Svensk katalog for locale-autopilot-year-end-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'ap.yearEnd.title': 'Bokslut {{year}}',
  'ap.yearEnd.progress': 'Förlopp i bokslutet',
  'ap.yearEnd.step.summary': 'Sammanfattning',
  'ap.yearEnd.step.review': 'Avklaringar',
  'ap.yearEnd.step.additions': 'Tillägg',
  'ap.yearEnd.step.final': 'Godkänn',
  'ap.yearEnd.step.submission': 'Inlämning',
  'ap.yearEnd.summaryTitle': 'Jag har kontrollerat årsunderlaget',
  'ap.yearEnd.summaryText': 'Du behöver bara hantera de punkter som inte kan avgöras säkert utifrån datan i Plumme.',
  'ap.yearEnd.approved': 'Kontrollerat och i ordning',
  'ap.yearEnd.notApplicable': 'Inte aktuellt',
  'ap.yearEnd.needsYou': 'Behöver hanteras',
  'ap.yearEnd.startReview': 'Hantera {{count}} punkter',
  'ap.yearEnd.continueAdditions': 'Fortsätt till tillägg',
  'ap.yearEnd.questionCount': '{{total}} punkter återstår',
  'ap.yearEnd.startReviewGroups': 'Hantera {{count}} grupper',
  'ap.yearEnd.groupCount': '{{total}} grupper återstår',
  'ap.yearEnd.confirmReviewed': 'Jag har kontrollerat och bekräftar',
  'ap.yearEnd.changeSomething': 'Jag behöver ändra något',
  'ap.yearEnd.openWorkArea': 'Öppna rätt arbetsområde',
  'ap.yearEnd.askAboutThis': 'Fråga AI om detta',
  'ap.yearEnd.handleCheck': 'Hantera',
  'ap.yearEnd.backToFlow': 'Tillbaka till bokslutet',
  'ap.yearEnd.openAsPage': 'Öppna som egen sida',
  'ap.yearEnd.workAreaNote': 'Kontrollpunkterna uppdateras utifrån det du gör här.',
  'ap.yearEnd.reviewDone': 'Alla kontrollpunkter är avklarade',
  'ap.yearEnd.reviewDoneText': 'Nu kontrollerar vi om du har andra uppgifter som inte finns i Plumme.',
  'ap.yearEnd.completeness': 'Fullständighetskontroll',
  'ap.yearEnd.anythingElse': 'Finns det något mer som ska läggas till?',
  'ap.yearEnd.anythingElseText': 'Beskriv det med egna ord. AI hjälper dig att hitta rätt område, men ändrar ingenting förrän du har kontrollerat och godkänt förslaget.',
  'ap.yearEnd.additionPlaceholder': 'Till exempel: Vi köpte en skåpbil i december, men fakturan kom i januari.',
  'ap.yearEnd.findAddition': 'Hitta rätt tillägg',
  'ap.yearEnd.showAllAdditions': 'Visa alla tillägg',
  'ap.yearEnd.noMore': 'Nej, jag har inget mer att lägga till',
  'ap.yearEnd.finalControl': 'Slutkontroll',
  'ap.yearEnd.readyTitle': 'Bokslutet är klart för godkännande',
  'ap.yearEnd.result': 'Årets resultat',
  'ap.yearEnd.backToReview': 'Hantera återstående punkter',
  'ap.yearEnd.completeAdditions': 'Slutför tilläggskontrollen',
  'ap.yearEnd.closeYear': 'Godkänn och avsluta räkenskapsåret',
  'ap.yearEnd.closing': 'Avslutar …',
  'ap.yearEnd.closedToast': 'Räkenskapsåret är avslutat.',
  'ap.yearEnd.saveError': 'Kunde inte spara bokslutet.',
  'ap.yearEnd.closeError': 'Kunde inte avsluta räkenskapsåret.',
  'ap.yearEnd.submissionTitle': 'Räkenskapsåret är avslutat',
  'ap.yearEnd.filedTitle': 'Bokslutet är klart',
  'ap.yearEnd.submissionText': 'Fortsätt med skattemeldingen och årsredovisningen. Senare ändringar görs tills vidare i fullständig vy.',
  'ap.yearEnd.ai.title': 'Fråga SuperPlumma',
  'ap.yearEnd.ai.context': 'Samtalet följer detta bokslut och denna kontrollpunkt.',
  'ap.yearEnd.ai.empty': 'Fråga varför punkten är relevant, vad ett begrepp betyder, eller beskriv något du tror saknas.',
  'ap.yearEnd.ai.placeholder': 'Vad undrar du?',
  'ap.yearEnd.ai.ask': 'Fråga',
  'ap.yearEnd.ai.thinking': 'Undersöker …',
  'ap.yearEnd.ai.error': 'Kunde inte hämta en förklaring just nu.',
  'ap.yearEnd.ai.noAnswer': 'Jag hittade inget säkert svar. Öppna fullständig vy för att kontrollera manuellt.',
  'ap.yearEnd.ai.proposalTitle': 'Förslag till skattepost',
  'ap.yearEnd.ai.assetGroup': 'Saldogrupp',
  'ap.yearEnd.ai.description': 'Beskrivning',
  'ap.yearEnd.ai.openingValue': 'Ingående värde',
  'ap.yearEnd.ai.acquisition': 'Nyanskaffning',
  'ap.yearEnd.ai.improvement': 'Förbättringsutgift',
  'ap.yearEnd.ai.proceeds': 'Ersättning',
  'ap.yearEnd.ai.depreciation': 'Avskrivning',
  'ap.yearEnd.ai.amount': 'Belopp',
  'ap.yearEnd.ai.bookPrevious': 'Bokfört värde i fjol',
  'ap.yearEnd.ai.taxPrevious': 'Skattemässigt värde i fjol',
  'ap.yearEnd.ai.bookCurrent': 'Bokfört värde i år',
  'ap.yearEnd.ai.taxCurrent': 'Skattemässigt värde i år',
  'ap.yearEnd.ai.approvalNote': 'Ingenting sparas förrän du godkänner. Posten valideras på nytt när den sparas.',
  'ap.yearEnd.ai.approve': 'Godkänn och lägg till',
  'ap.yearEnd.ai.saved': 'Skatteposten har lagts till i utkastet. Du kan beskriva fler uppgifter om något annat saknas.',
  'ap.yearEnd.ai.savedToast': 'Skattepost tillagd',
  'ap.yearEnd.ai.saveError': 'Kunde inte spara skatteposten.',
  'ap.yearEnd.ai.draftInProgress': 'Förslag pågår',
  'ap.yearEnd.ai.cancelDraft': 'Avsluta',
  'ap.agentName.bookkeeping': 'Bokföringsagenten',
  'ap.agentName.tax': 'Skatteagenten',
  'ap.agentName.annual': 'Årsredovisningsagenten',
  'ap.followup.bank': 'Bankavstämning',
  'ap.followup.title': 'Uppföljning',
  'ap.followup.countOne': '{{count}} punkt behöver följas upp.',
  'ap.followup.countMany': '{{count}} punkter behöver följas upp.',
  'ap.agent.tax.titleMissing': '{{count}} förutsättningar saknas före skattemeldingen',
  'ap.agent.annual.titleMissing': '{{count}} förutsättningar saknas före årsredovisningen',
  'ap.readiness.yearOpen': 'Räkenskapsåret är inte avslutat',
  'ap.readiness.yearOpenSub': 'Bokslutet är inte genomfört',
  'ap.readiness.inbox': '{{count}} verifikationer är inte färdigbehandlade',
  'ap.readiness.inboxSub': 'Slutför inkorgen före årsinlämningen',
  'ap.readiness.bank': '{{count}} bankrader är inte färdigavstämda',
  'ap.readiness.bankSub': 'Slutför bankavstämningen',
  'ap.readiness.previousTax': 'Föregående skattemelding är inte bekräftad som inlämnad',
  'ap.readiness.reviewYear': 'Kontrollera {{year}}',
  'ap.review.all': 'Alla',
  'ap.review.withVoucher': 'Med verifikation',
  'ap.review.matched': 'Matchad',
  'ap.review.missingVoucher': 'Saknar verifikation',
  'ap.review.needsChecking': 'Behöver kontrolleras',
  'ap.review.createsDeviation': 'Skapar avvikelse',
  'ap.review.upToDate': 'Aktuell',
  'ap.review.approvedNotPosted': 'Godkänd · inte bokförd',
  'ap.review.blocked': 'Blockerad',
  'ap.review.ready': 'Klar',
  'ap.review.yourAccounts': 'Din bokföring',
  'ap.review.exampleData': 'Exempeldata',
  'ap.review.voucherLinked': '✓ Verifikation kopplad',
  'ap.review.hideVoucher': 'Dölj verifikation',
  'ap.review.showVoucher': 'Visa verifikation',
  'ap.review.allVouchersLinked': 'Alla verifikationer är kopplade 🎉',
  'ap.review.deadline': 'Deadline',
  'ap.review.readyForApproval': 'Klar för godkännande',
  'ap.surface.fullscreen': 'Visa i helskärm',
  'ap.surface.exitFullscreen': 'Avsluta helskärm',
  'ap.surface.voucherCount': '{{count}} verifikationer',
  'ap.surface.outsideMonth': '{{count}} utanför månaden',
  'ap.surface.accountsAndVouchers': 'Konto och verifikationer utan bankrad',
  'ap.yearEnd.bank.title': 'Bankavstämning {{year}}',
  'ap.yearEnd.bank.note': 'Välj den månad som ska kontrolleras för detta bokslut.',
  'ap.yearEnd.bank.openLines': '{{count}} öppna bankrader',
  'ap.yearEnd.bank.missingStatements': '{{count}} bankkonton saknar kontoutdrag',
  'ap.yearEnd.bank.done': 'Avstämd och arkiverad',
  'ap.yearEnd.bank.needsArchive': 'Kontrollera arkivering',
  'ap.yearEnd.bank.noStatement': 'Inget kontoutdrag',
  'ap.yearEnd.backToWorkArea': 'Tillbaka till {{title}}',
  'ap.surface.bankUploadUnavailable': 'Uppladdning av kontoutdrag är inte tillgänglig ännu.',
  'ap.surface.bankReadError': 'Kunde inte läsa kontoutdraget.',
  'ap.surface.bankLoadErrorTitle': 'Avstämningen kunde inte läsas in',
  'ap.surface.bankLoadErrorDetail': 'Ladda om sidan, eller öppna kontoutdraget från Bank.',
  'ap.surface.assetMovedToExpense': 'Verifikationen har flyttats ut ur tillgångskontrollen. Kontrollera konto och moms i bokföringslistan.',
  'ap.surface.assetSkipError': 'Kunde inte hoppa över registrering av tillgång.',
  'ap.surface.assetTitle': 'Möjliga inventarier',
  'ap.surface.assetSubtitle': '{{count}} verifikationer över beloppsgränsen',
  'ap.surface.assetEmptyTitle': 'Inga tillgångsförslag kvar',
  'ap.surface.assetChooseHelp': 'Välj om verifikationen ska registreras som inventarie eller skickas tillbaka till vanlig bokföringskontroll. Köpet bokförs bara en gång.',
  'ap.surface.assetNotAsset': 'Inte inventarie',
  'ap.surface.inboxTitle': 'Verifikationsinkorgen',
});
